module.exports = __webpack_public_path__ + "static/img/didi.e66bdb0a.jpg";